import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { fieldsMap } from '../fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	fieldsMap.get('type_payment_method'),
	{
		config: {
			flexLayout: 'row'
		},
		fields: [
			fieldsMap.get('source_code_payment'),
			fieldsMap.get('target_code_payment')
		]
	}
];

const config: IFormConfig = {
	title: 'Crea mappatura metodo di pagamento',
	editTitle: 'Modifica mappatura metodo di pagamento',
	fields: formFields
};

export default config;
